<template>
    <div class="single__documents container-max">
        <a v-if="currentVariation && currentVariation.item.free1"
           target="_blank"
           :title="$translate('Weberbuero::Template.singlePDFCatalog')"
           :href="currentVariation.item.free1">
            <svg width="28" height="35">
                <use xlink:href="#svg_pdf-download" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
            </svg>
            {{ $translate("Weberbuero::Template.singlePDFCatalog") }}
        </a>
        <a v-if="currentVariation && currentVariation.item.free3"
           target="_blank"
           :title="$translate('Weberbuero::Template.singlePDFCatalog2')"
           :href="currentVariation.item.free3">
            <svg width="28" height="35">
                <use xlink:href="#svg_pdf-download" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
            </svg>
            {{ $translate("Weberbuero::Template.singlePDFCatalog2") }}
        </a>
        <a v-if="currentVariation && currentVariation.item.free13"
           target="_blank"
           :title="$translate('Weberbuero::Template.singlePDFCatalogMontage')"
           :href="currentVariation.item.free13">
            <svg width="28" height="35">
                <use xlink:href="#svg_pdf-download" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
            </svg>
            {{ $translate("Weberbuero::Template.singlePDFCatalogMontage") }}
        </a>
    </div>
</template>

<script>
import { get } from "ceres/app/helper/get";

export default {

	inject: {
		itemId: {
			default: null
		}
	},

    computed: {
        currentVariation() {
            return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
        }
    }
}
</script>
